import axios from "axios";
const API_URL = 'http://localhost:8080/api'

export const CreateListing = async (values) => {
    
  try {
      const { data } = await axios.post(
          `${API_URL}/create/listing`,
          {
              ...values,
          },
          { withCredentials: true }
      );
      if (data) {
          if (data.errors) {
            
          } else {
            
             return data
          }
      }
  } catch (ex) {
      
  }
};